/**
 * Formats an error into a consistent string for Amplitude event properties.
 * Returns 'N/A' when there is no error, or '{ErrorName}: {ErrorDetails}' otherwise.
 */
const formatAmplitudeError = (error?: unknown): string => {
  if (error == null) return 'N/A';

  const errorName = error instanceof Error && error.name ? error.name : 'Error';

  let errorDetails = 'Unknown';
  if (error instanceof Error) {
    errorDetails = error.message || 'Unknown';
  } else if (typeof error === 'string') {
    errorDetails = error;
  }

  return `${errorName}: ${errorDetails}`;
};

export default formatAmplitudeError;
